export const OCR_DATE_FORMATS = [
  "DD-MM-YYYY",
  "DD/MM/YYYY",
  "MM/DD/YYYY",
  "MM-DD-YYYY",
  "YYYY/MM/DD",
  "YYYY/DD/MM",
  "YYYY-MM-DD",
  "YYYY-DD-MM",
]

export const TAB = {
  FACTURA_TAB: "FACTURA_TAB",
  PROVEEDOR_TAB: "PROVEEDOR_TAB",
  CLIENTE_TAB: "CLIENTE_TAB",
  IMPORTE_TAB: "IMPORTE_TAB",
}
